import Navigation from "./Navigation";
import { LIBRARY_PATH } from "@/utils/promptLibraryShare";
import { PromptLibraryAI30Link } from "./PromptLibraryAI30";
import { useHydratedSearch } from "@/hooks/useHydratedSearch";
import { promptLibraryCampaignQuery } from "@/utils/promptLibraryConversion";

export function PromptLibraryNavigation() {
  const campaignQuery = promptLibraryCampaignQuery(useHydratedSearch());
  return (
    <Navigation hideCTA logoClassName="h-5 w-auto sm:h-10">
      <a
        href={`${LIBRARY_PATH}${campaignQuery}#workflow-search`}
        className="inline-flex min-h-11 items-center text-sm font-semibold text-foreground underline underline-offset-4 hover:text-primary"
      >
        <span className="sm:hidden">Workflows</span>
        <span className="hidden sm:inline">Find a workflow</span>
      </a>
      <PromptLibraryAI30Link placement="navigation" className="px-3 text-sm">
        AI 30 for teams
      </PromptLibraryAI30Link>
    </Navigation>
  );
}
